import React, { useEffect } from "react"

const TAPI_SCRIPT_ID = "tapi-embed-js"
const TAPI_RESIZE_SCRIPT_ID = "tapi-embed-resize-js"

// Tapi's embed.js only builds the iframe once per full page load, so remove and re-add
// the scripts on every mount to make it work with Gatsby client-side navigation
const removeTapiScripts = () => {
  [TAPI_SCRIPT_ID, TAPI_RESIZE_SCRIPT_ID].forEach((id) => {
    const script = document.getElementById(id)
    if (script) script.remove()
  })
}

const TapiEmbed = ({ managementId }) => {
  useEffect(() => {
    if (!managementId) return

    removeTapiScripts()
    const script = document.createElement("script")
    script.id = TAPI_SCRIPT_ID
    script.src = "https://eu.tapi.app/js/embed.js"
    document.head.appendChild(script)

    return () => removeTapiScripts()
  }, [managementId])

  if (!managementId) return null

  return (
    <div className="tapi-embed">
      <div className="tapi-embedded-request" data-company={managementId} data-type="bot"></div>
    </div>
  )
}

export default TapiEmbed
